import { ol_control, ol_Map, ol_Observable_unByKey } from "@omnia/exports/openlayers";
import { calculateAngle } from "../utils/geom";
import * as easing from "ol/easing";


export class RotateControl extends ol_control.Control {

    static create(): RotateControl {

        let element = RotateControl.createElement();

        return new RotateControl(element);

    }

    static createElement(): HTMLElement {

        let container = document.createElement("div");

        container.className = "ol-unselectable omnia-map-rotate";

        let img = <HTMLImageElement><any>document.createElement("img");
        img.src = "/images/generic/compass.png";
        img.draggable = false;

        container.appendChild(img);

        return container;

    }

    private _drag: boolean;
    private _dragOrigin: [number, number];
    private _releaseDrag: Function;
    private _center: [number, number];
    private _initialRotation: number;
    private _moved: boolean;

    private _rotationWatcher: any;


    constructor(element: HTMLElement) {


        super({
            element: element
        });

        element.addEventListener("mousedown", e => this.handleMouseDown(e));

    }

    setMap(map: ol_Map) {
        super.setMap(map);
        this.watchRotation(true);
    }

    private watchRotation(watch: boolean) {

        if (this._rotationWatcher) {
            ol_Observable_unByKey(this._rotationWatcher);
            this._rotationWatcher = undefined;
        }

        if (watch) {
            let map = this.getMap();
            if (map) {
                let view = map.getView();
                this._rotationWatcher = view.on("change:rotation", () => {
                    let rotation = view.getRotation();
                    this.rotateCompass(rotation);
                });
            }
        }
    }

    private handleMouseDown(e: MouseEvent) {

        if (!this._drag) {

            this.watchRotation(false);

            this._drag = true;
            this._dragOrigin = [e.x, e.y];

            let rect = this.element.getBoundingClientRect();

            this._center = [rect.left + (rect.width / 2), rect.top + (rect.height / 2)];

            this._initialRotation = this.getMap().getView().getRotation();

            this._moved = false;

            let move = (e: MouseEvent) => this.handleMouseMove(e);
            let up = (e: MouseEvent) => this.handleMouseUp(e);

            this._releaseDrag = () => {
                document.removeEventListener("mousemove", move);
                document.removeEventListener("mouseup", up);
            }

            document.addEventListener("mousemove", move);
            document.addEventListener("mouseup", up);

        }

    }

    private handleMouseMove(e: MouseEvent) {

        if (this._drag) {

            let p = [e.x, e.y];

            if (this._moved || (p[0] != this._dragOrigin[0]) || (p[1] != this._dragOrigin[1])) {
                let angle = calculateAngle(this._center, this._dragOrigin, p);
                let rotation = this._initialRotation + angle;
                this.setRotation(rotation);
                this._moved = true;
            }

        }
    }

    private handleMouseUp(e: MouseEvent) {

        this.element.setPointerCapture
        this._drag = false;
        this._dragOrigin = undefined;
        this._releaseDrag();
        this._releaseDrag = null;

        this.watchRotation(true);

        if (!this._moved) {

            let view = this.getMap().getView();

            (<any>view).animate({
                rotation: 0,
                duration: 500,
                easing: easing.easeOut
            });

        }

    }

    private setRotation(rotation: number) {
        this.getMap().getView().setRotation(rotation);
        this.rotateCompass(rotation);
    }

    private rotateCompass(rotation: number) {
        (<HTMLElement>(this.element.firstChild)).style.transform = `rotate(${rotation}rad)`;
    }
}
